import { routes } from '../../../constants/routes'

export type RootSubPage = {
  name: string
  path: string | string[]
  inactive?: boolean
}

export type RootPage = {
  name: string
  path: string
  inactive?: boolean
}

export const menuTabList: RootPage[] = [
  {
    name: 'Treasury Management',
    path: routes.TREASURY,
  },
  {
    name: 'Spot Trading',
    path: routes.SPOT_TRADING,
  },
  {
    name: 'Account',
    path: routes.ACCOUNT_ADMIN,
  },
  {
    name: 'Staking',
    path: routes.STAKING,
    inactive: true,
  },
  {
    name: 'Portfolio',
    path: routes.PORTFOLIO,
    inactive: false,
  },
]
